import { useState } from "react";
import { Loader2, Megaphone, Lock } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { startCheckout } from "../lib/api";

export const REFERRAL_MESSAGE = "Tell the supplier that seedosellz sent me.";

export const CheckoutDialog = ({ product, open, onOpenChange }) => {
  const [loading, setLoading] = useState(false);

  const go = async () => {
    setLoading(true);
    try {
      await startCheckout(product.id);
    } catch {
      toast.error("Checkout couldn't start. Please try again.");
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-lenis-prevent className="w-[calc(100%-2rem)] max-w-md rounded-none border-gold/40 bg-[#100719] text-white p-7 sm:p-8" data-testid="checkout-dialog">
        <p className="text-[11px] tracking-[0.4em] uppercase text-gold">Checkout</p>
        <DialogTitle className="font-display font-black uppercase text-2xl leading-tight" data-testid="checkout-dialog-product">{product.name}</DialogTitle>
        <DialogDescription className="font-mono text-gold text-lg">${product.price}</DialogDescription>
        <div className="border-l-2 border-violet-500 bg-violet-950/60 px-4 py-3 flex gap-3" data-testid="checkout-referral-message">
          <Megaphone className="w-4 h-4 text-gold shrink-0 mt-0.5" />
          <p className="text-sm text-amber-100"><strong>Important:</strong> {REFERRAL_MESSAGE}</p>
        </div>
        <p className="text-xs text-violet-200/80">After paying you'll get a private access page to view and download your PDF, also sent to your email.</p>
        <button onClick={go} disabled={loading} className="btn-gold w-full py-4 text-xs" data-testid="checkout-continue-btn">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Lock className="w-3.5 h-3.5 mr-2" />Secure checkout</>}
        </button>
      </DialogContent>
    </Dialog>
  );
};
